import z from 'zod';
import type { CboRecordDto } from './cboRecord.dto';

/**
 * Postal address fields available on legacy resource DTOs.
 */
export interface ResourceAddressDto {
  line1?: string;
  line2?: string;
  city?: string;
  state?: string;
  zip?: string;
  description?: string;
}

/**
 * Minimal resource reference used by legacy resource interactions.
 */
export interface ResourceDto {
  title: string;
  findHelpId?: string;
  phoneNumber?: string;
  address?: ResourceAddressDto;
}

export interface ResourceDetailsDto {
  findHelpId?: number;
  title: string;
  providerName: string;
  tags: ResourceTagDto[];
  description: string;
  locations: ResourceLocationDto[];
  websiteUrl: string;
  freeOrReduced: '' | 'free' | 'reduced';
  supportedLanguages: string[];
}

interface Address extends ResourceAddressDto {
  primary?: boolean;
  src?: string;
}
export interface ResourceLocationDto {
  name: string;
  email: string;
  phoneNumber: string;
  hours: {
    day: string;
    open: boolean;
    allDay: boolean;
    startTime: string;
    endTime: string;
  }[];
  timezone: string;
  address: Address;
}

export interface ResourceInteractionDto {
  resource: ResourceDto;
  userNeedId?: number;
  interactionId: number;
}
export interface NeedResourceInteractionDto {
  resource: ResourceDto;
  userNeedId?: number;
  interactionId: number;
  cboRecord?: CboRecordDto;
}

export interface ResourceTagDto {
  key: string;
  name: string;
  children: ResourceTagDto[];
}

export interface ResourcingRequest {
  title?: string;
  phoneNumber?: string;
  findHelpId?: string;
  userNeedId?: number;
  address?: Address;
  /** Canonical CBO row when saved via the shared CBO form. */
  cboRecordId?: string;
}

export const ResourceAddressSchema = z.object({
  line1: z.string().optional(),
  line2: z.string().optional(),
  city: z.string().optional(),
  state: z.string().optional(),
  zip: z.string().optional(),
  description: z.string().optional(),
  primary: z.boolean().optional(),
  src: z.string().optional(),
});

export const ResourcingRequestSchema = z.object({
  title: z.string().optional().nullable(),
  phoneNumber: z.string().optional().nullable(),
  findHelpId: z.string().optional().nullable(),
  userNeedId: z.number().optional().nullable(),
  address: ResourceAddressSchema.optional().nullable(),
  cboRecordId: z.string().optional().nullable(),
});
export type ResourcingRequestForm = z.infer<typeof ResourcingRequestSchema>;
